<script>
  export let open = false
  import {
    createEventDispatcher
  } from 'svelte';

  const dispatch = createEventDispatcher();
</script>

<button on:click="{() => dispatch('pressed', 'settings')}" type="button" aria-label="Play">
  {#if open}
  <svg class="exit" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g id="cancel_24px">
    <path id="icon/navigation/cancel_24px" fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.47 6.46997 2 12 2C17.53 2 22 6.47 22 12C22 17.53 17.53 22 12 22C6.46997 22 2 17.53 2 12ZM15.59 17L17 15.59L13.41 12L17 8.41L15.59 7L12 10.59L8.41003 7L7 8.41L10.59 12L7 15.59L8.41003 17L12 13.41L15.59 17Z" fill="#333333"/>
    </g>
  </svg>
  {:else}
  <svg class="settings" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g xmlns="http://www.w3.org/2000/svg" id="settings_24px">
<path id="icon/action/settings_24px" fill-rule="evenodd" clip-rule="evenodd" d="M19.425 13.01L19.435 12.99L21.545 14.65C21.735 14.79 21.875 14.91 21.875 14.91L19.445 19.11L16.565 17.96L16.585 17.92C16.055 18.33 15.475 18.67 14.855 18.93H14.865L14.485 21.58C14.455 21.82 14.425 22 14.425 22H9.57499L9.12499 18.92H9.15499C8.52499 18.66 7.95499 18.32 7.42499 17.91L7.44499 17.95L4.56499 19.1L2.13499 14.9C2.13499 14.9 2.27499 14.79 2.46499 14.64L4.56499 12.99L4.57499 13.01C4.52499 12.68 4.49499 12.34 4.49499 12C4.49499 11.66 4.52499 11.34 4.56499 11.01L4.55499 11.03L2.11499 9.11L4.55499 4.89L7.43499 6.06L7.42499 6.07C7.94499 5.67 8.51499 5.33 9.13499 5.07H9.12499L9.56499 2H14.435L14.895 5.06H14.885C15.505 5.32 16.075 5.66 16.595 6.06L16.585 6.05L19.455 4.89L21.885 9.11L19.445 11.03L19.435 11.01C19.475 11.34 19.505 11.66 19.505 12C19.505 12.34 19.465 12.68 19.425 13.01ZM8.49499 12C8.49499 13.93 10.065 15.5 11.995 15.5C13.925 15.5 15.495 13.93 15.495 12C15.495 10.07 13.925 8.5 11.995 8.5C10.065 8.5 8.49499 10.07 8.49499 12Z" fill="#333333"/>
</g>
  </svg>
  {/if}
</button>

<style>
  button {
    position: relative;
    top: 0;
    left: 0;
    padding: 16px;
    background: #FDFFFC;
    border: 2px solid #202020;
    box-shadow: 4px 4px 0px #FF9F1C;
    border-radius: 20px;
    transition: 0.1s;
    outline: none;
    max-width: 40px;
    max-height: 40px;
  }

  button:hover,
  button:focus {
    top: 2px;
    left: 2px;
    box-shadow: 2px 2px 0px #FF9F1C;
  }

  button:active {
    top: 4px;
    left: 4px;
    box-shadow: 0px 0px 0px;
  }

  .settings, .exit{
    position: relative;
    top: -10px;
    left: -10px;
  }

</style>
